if (!customElements.get('subscription-widget-option')) {
  customElements.define('subscription-widget-option', 
    class SubscriptionWidgetOption extends HTMLElement {
      constructor() {
        super();

        this.input = this.querySelector('input[type="radio"]');
        this.select = this.querySelector("select");

        this.priceWrapper = this.querySelector(".subscription-price-wrapper");
        this.currentPriceElement = this.querySelector("[data-current-price]");
        this.comparePriceElement = this.querySelector("[data-compare-price]");

        this.sellingPlanId = '';
        this.price = parseInt(this.dataset.price, 10) || 0;
        this.compareAtPrice = parseInt(this.dataset.compareAtPrice, 10) || this.price;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.updateSellingPlanId();
        this.updatePrice();
        this.initEventListeners();

        if (this.input.checked) {
          this.check();
        }
      }

      initEventListeners() {
        this.input?.addEventListener("change", () => {
          if (this.input.checked) {
            this.check();
          }
        });

        this.select?.addEventListener("change", () => {
          this.handleSelectChange();
        });

        this.addEventListener("click", () => {
          this.input.click();
        });
      }

      check() {
        if (this.input) {
          this.input.checked = true;
        }

        this.emitSellingPlanChange();
      }

      handleSelectChange() {
        this.updateSellingPlanId();
        this.updatePrice();
        this.updateWidgetContent();
        this.check();
      }

      updateSellingPlanId() {
        if (!this.select || this.select.options.length === 0 || !this.select.options[this.select.selectedIndex].dataset.sellingPlanId) {
          return;
        }

        this.sellingPlanId =
          this.select.options[this.select.selectedIndex].dataset.sellingPlanId;
      }

      updatePrice() {
        if (!this.select || this.select.options.length === 0 || !this.select.options[this.select.selectedIndex].dataset.price) {
          return;
        }

        this.price = parseInt(this.select.options[this.select.selectedIndex].dataset.price);
        this.compareAtPrice =
          parseInt(this.select.options[this.select.selectedIndex].dataset.compareAtPrice, 10) || this.price;
      }

      updateWidgetContent() {
        if (!this.priceWrapper || !this.currentPriceElement || !this.comparePriceElement) return;

        const isOnSale = this.compareAtPrice > this.price;
        this.currentPriceElement.textContent = this.formatMoney(this.price);
        this.currentPriceElement.classList.toggle('is-sale', isOnSale);
        this.comparePriceElement.textContent = this.formatMoney(this.compareAtPrice);
        this.comparePriceElement.classList.toggle('hidden', !isOnSale);
      }

      formatMoney(amount) {
        if (window.FoxTheme?.Currency) {
          return FoxTheme.Currency.formatMoney(
            amount,
            FoxTheme.settings.moneyFormat
          );
        }

        return amount;
      }

      emitSellingPlanChange() {
        if (window.FoxTheme?.pubsub) {
          FoxTheme.pubsub.publish(
            FoxTheme.pubsub.PUB_SUB_EVENTS.sellingPlanChange,
            {
              data: {
                sellingPlanId: this.sellingPlanId,
                productId: this.dataset.productId,
                addButtonLabel: this.dataset.checkoutButtonLabel,
                price: this.price,
                compareAtPrice: this.compareAtPrice,
              },
            },
          );
        }
      }
    }
  )
}
